import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_membership_class_hdr_RowClass, bl_crm_membership_ext_RowClass, bl_crm_membership_hdr_RowClass} from '../../../dbschema';

export class MembershipCardClassContainerModel extends BaseContainerModel {
  bl_crm_membership_hdr: bl_crm_membership_hdr_RowClass = new bl_crm_membership_hdr_RowClass();
  bl_crm_membership_ext: bl_crm_membership_ext_RowClass[] = [];
  bl_crm_membership_class_hdr: bl_crm_membership_class_hdr_RowClass = new bl_crm_membership_class_hdr_RowClass(); 
}
